import glamorous from 'glamorous';

/*
style={{ background: 'black', opacity: '0.5' }}
*/

export const Logos = glamorous.div({
  width: '100%',
  height: '80px',
  textAlign: 'center'
});

export const Logo = glamorous.img({
  height: '40px',
  padding: '0px 15px 0px 15px',
  '@media(max-width: 767px)': {
    padding: '0px 8px 0px 8px',
  }
});

export const Title = glamorous.h1({
  fontFamily: 'pp-sans-big-light',
  fontSize: '25px',
  lineHeight: '1.68',
  textAlign: 'center',
});

export const Content = glamorous.p({
  marginTop: '20px',
  marginBottom: '20px',
  fontFamily: 'pp-sans-small-light',
  fontSize: '15px',
  fontWeight: '300',
  lineHeight: '1.6',
  textAlign: 'center',
});

export const ButtonContainer = glamorous.div({
  textAlign: 'center',
  marginBottom: '60px',
  marginTop: '32px',
});

export const Confirm = glamorous.button({
  borderRadius: '50px',
  border: 'solid 1px #0070ba',
  fontFamily: 'pp-sans-small-regular',
  fontSize: '15px',
  fontWeight: '500',
  color: '#0070ba',
  backgroundColor: 'white',
  width: '70%',
  height: '50px',

  ':hover': {
    color: 'white',
    backgroundColor: '#0070ba',
  },

  ':visited': {
    border: 'none'
  },

  ':focus': {
    outline: '0'
  }

});
